var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-ring",style:({
    background: `radial-gradient(
      closest-side, ${
        _vm.isDarkMode ? 'var(--paper-background-color)' : 'white'
      } 75%, transparent 75% 100%
      ), conic-gradient(
        ${_vm.primaryColor} ${_vm.progressPercent}, ${_vm.secondaryColor} 0)
      `,
  })},[(_vm.showNumeratorDenominator)?_c('div',{staticClass:"progress-amount"},[_c('span',{staticClass:"numerator"},[_vm._v(_vm._s(_vm.numerator))]),_c('span',{staticClass:"denominator"},[_vm._v("/"+_vm._s(_vm.denominator))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }